import { call, put, all, takeLatest } from 'redux-saga/effects';
import api from '../../../services/api';
import { toast } from 'react-toastify';
import {
  fetchDashboardSuccess,
  fetchDashboardFailure,
  fetchUsersSuccess,
  fetchUsersFailure,
  fetchUserDetailSuccess,
  fetchUserDetailFailure,
  fetchPaymentsSuccess,
  fetchPaymentsFailure,
} from './actions';
import { AdminTypes } from './types';

export function* fetchDashboard() {
  try {
    const response = yield call(api.get, '/admin/dashboard');
    yield put(fetchDashboardSuccess(response.data));
  } catch (error) {
    yield put(fetchDashboardFailure());
    toast.error('Erro ao carregar dashboard.');
  }
}

export function* fetchUsers() {
  try {
    const response = yield call(api.get, '/admin/users');
    yield put(fetchUsersSuccess(response.data));
  } catch (error) {
    yield put(fetchUsersFailure());
    toast.error('Erro ao carregar usuários.');
  }
}

export function* fetchUserDetail(action: any) {
  try {
    const { id } = action.payload;
    const response = yield call(api.get, `/admin/users/${id}`);
    yield put(fetchUserDetailSuccess(response.data));
  } catch (error) {
    yield put(fetchUserDetailFailure());
    toast.error('Erro ao carregar detalhes do usuário.');
  }
}

export function* fetchPayments(action: any) {
  try {
    const filters = (action.payload && action.payload.filters) || {};
    const params = new URLSearchParams();
    if (filters.status) params.append('status', filters.status);
    if (filters.month) params.append('month', filters.month);
    if (filters.source) params.append('source', filters.source);

    const query = params.toString() ? `?${params.toString()}` : '';
    const response = yield call(api.get, `/admin/payments${query}`);
    yield put(fetchPaymentsSuccess(response.data));
  } catch (error) {
    yield put(fetchPaymentsFailure());
    toast.error('Erro ao carregar pagamentos.');
  }
}

export default all([
  takeLatest(AdminTypes.FETCH_DASHBOARD_REQUEST, fetchDashboard),
  takeLatest(AdminTypes.FETCH_USERS_REQUEST, fetchUsers),
  takeLatest(AdminTypes.FETCH_USER_DETAIL_REQUEST, fetchUserDetail),
  takeLatest(AdminTypes.FETCH_PAYMENTS_REQUEST, fetchPayments),
]);
